import { FunctionComponent } from "react";
import Frames1 from "../components/Frames1";
import InputField from "../components/InputField";
import FooterFrame from "../components/FooterFrame";
import MainstreamBrands from "../components/MainstreamBrands";

const Contact: FunctionComponent = () => {
  return (
    <div className="w-full relative bg-white overflow-hidden flex flex-col items-start justify-start pt-0 px-0 pb-[2036px] box-border gap-[10px] tracking-[normal]">
      <Frames1 />
      <section className="self-stretch h-[1089px] overflow-y-auto shrink-0 flex flex-col items-start justify-start pt-[88px] px-0 pb-0 box-border gap-[10px] max-w-full text-center text-[120px] text-gray-100 font-racing-sans-one lg:pt-[37px] lg:box-border mq450:pt-5 mq450:box-border mq1050:pt-6 mq1050:box-border">
        <InputField />
        <div className="self-stretch bg-gray-500 flex flex-row items-center justify-center max-w-full shrink-0">
          <div className="flex-1 flex flex-col items-start justify-end py-0 px-2.5 box-border max-w-full">
            <h2 className="m-0 self-stretch h-[302px] relative text-inherit font-normal font-inherit flex items-center mq450:text-[30px] mq1050:text-29xl">
              <span>
                <p className="m-0">{`FILL OUT NOW SO `}</p>
                <p className="m-0">YOUR IN THE LOOP!</p>
              </span>
            </h2>
          </div>
        </div>
        <div className="self-stretch flex flex-col items-start justify-start gap-[10px] max-w-full shrink-0 text-left text-5xl text-black font-radley">
          <FooterFrame />
          <MainstreamBrands />
          <div className="w-[622px] flex flex-row items-start justify-start py-0 px-[50px] box-border max-w-full mq750:pl-[25px] mq750:pr-[25px] mq750:box-border">
            <div className="h-[30px] flex-1 relative flex items-center max-w-full mq450:text-lgi">
              Copyright © MONBITATNI Mountain Bike Shop
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
